import { cn } from '@/lib/utils';
import { FunctionComponent } from 'react';
import { createPortal } from 'react-dom';
import { ITooltip, Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

interface iPortalTooltipProps extends ITooltip {}

const PortalTooltip: FunctionComponent<iPortalTooltipProps> = ({ children, style = {}, ...props }) => {
  const container = document.getElementById('tooltip');
  if (!container) return null;
  return createPortal(
    <Tooltip
      {...props}
      disableStyleInjection
      className={cn(
        'tooltip bg-slate-700! dark:bg-stone-800! opacity-95! backdrop-blur-md! dark:border! dark:border-stone-700/20! rounded-[5px]!',
      )}
      style={{
        // backgroundColor: 'rgb(51, 65, 85)',
        padding: '4px 10px',
        fontFamily: 'Geist',
        fontWeight: 500,
        fontSize: '14px',
        ...style,
        zIndex: 9999,
      }}>
      {children}
    </Tooltip>,
    container,
  );
};

export default PortalTooltip;
